<!-- Search field -->
@if (isSearch()) {
  <ui-search [(value)]="term" [showButton]="false" [showIcon]="true" [placeholder]="searchPlaceholder()" (onSearch)="onSearchHandler($event)"></ui-search>
}

@if (showFilters()) {
  @for (row of filterRows(); track $index) {
    <div class="filters" [class.wrap]="wrap() || hasNewLineFilters()">
      <!-- Filter items -->
      @for (flt of row; track flt.id) {
        @if (flt.type === 'checkbox') {
          <div class="filter-item filter-checkbox" [style.flex-basis]="flt.width">
            <input [id]="flt.id" type="checkbox" [(ngModel)]="flt.value" (change)="onFilter(flt)">
            <label [for]="flt.id">{{ flt.label }}</label>
          </div>
        } @else if (flt.type === 'text') {
          <input
            type="text"
            #inp
            [style.flex-basis]="flt.width"
            [placeholder]="flt.label || ''"
            [(ngModel)]="flt.value"
            (keydown.enter)="inp.blur()"
            (blur)="onFilter(flt)"
          >
        } @else if (flt.type === 'toggle-buttons') {
          <div class="filter-item filter-toggle-buttons" role="tablist" [style.flex-basis]="flt.width">
            @for (item of itemsOf(flt); track item.id) {
              <button
                class="ui-pill-button"
                type="button"
                role="tab"
                [class.selected]="flt.value === item.id"
                [attr.aria-selected]="flt.value === item.id"
                (click)="selectToggle(flt, item)"
              >{{ item.value }}</button>
            }
          </div>
        } @else if (flt.type === 'date') {
          <input
            type="date"
            #inp
            [class.empty]="!flt.value"
            [style.flex-basis]="flt.width"
            [placeholder]="flt.label || ''"
            [(ngModel)]="flt.value"
            (keydown.enter)="inp.blur()"
            (change)="onFilter(flt)"
            (blur)="onFilter(flt)"
          >
        } @else {
          <ng-select
            bindLabel="value"
            [bindValue]="flt.search ? '' : 'id'"
            [ui-wide-dropdown]="flt.wide"
            [class]="flt.class || ''"
            [style.flex-basis]="flt.width"
            [placeholder]="flt.label || ''"
            [(ngModel)]="flt.value"
            [items]="itemsOf(flt)"
            [typeahead]="getTypeahead(flt)!"
            [compareWith]="(flt.search ? compareItems : undefined)!"
            [loading]="isLoading(flt)"
            [clearable]="false"
            [searchable]="flt.dropdownSearch || flt.multiple || !!flt.search"
            [multiple]="flt.multiple || false"
            [closeOnSelect]="!(flt.multiple || false)"
            [appendTo]="flt.wide ? 'body' : (flt.appendTo || '')"
            (open)="onDropdownOpen(flt)"
            (change)="onFilter(flt)"
          ></ng-select>
        }
      }
    </div>
  }
}

<!-- Pills -->
@if (hasFilters()) {
  <div class="pills">
    @if (term()) {
      <ui-filter-pill (click)="onSearchHandler(''); term.set('')">Search: "{{ term() }}"</ui-filter-pill>
    }

    @for (flt of items() | filterHidden; track trackFilter(flt)) {
      @if (flt.value !== undefined) {
        @if (flt.multiple && flt.separatePills) {
          @for (v of flt.value; track v) {
            <ui-filter-pill (click)="removeFilterValue(flt, v)">{{ getFilterValue(flt, v) }}</ui-filter-pill>
          }
        } @else {
          <ui-filter-pill (click)="removeFilter(flt)">{{ getFilterValue(flt) }}</ui-filter-pill>
        }
      }
    }

    <!-- Clear button -->
    <button class="ui-link btn-clear" (click)="onClear()">Clear filters</button>
  </div>
}

<!--<button
  class="btn-gray btn-filters"

>
&lt;!&ndash;  ui-scroll-visibility="400"&ndash;&gt;
  <span class="ui-icon-filter mr10"></span>Filters
</button>-->
